import { EN_DASH } from "./constants";

export function formatTicketName(
  ticketName: string,
  pricingTierName: string | null | undefined
) {
  if (!pricingTierName) {
    return ticketName ?? "";
  }

  if (!ticketName) {
    return pricingTierName;
  }

  return `${ticketName} ${EN_DASH} ${pricingTierName}`;
}
